import React, { Component, Suspense } from 'react';
import { Router } from 'react-router-dom';
import { history } from '../history';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { toJS, observable, computed } from 'mobx';
import { TutorialPreload } from './TutorialPreload';
import { observer } from 'mobx-react';
import { Splash } from './Splash';
import { debounce } from 'lodash';
import { User } from '../stores/models/User';
import { PhaserGame } from './PhaserGame';
import { AnimatePresence } from 'framer-motion';
import { Sprite } from './Sprite';
import { Spinner } from '../elements/Elements';
import {integration} from '../integration';
import {i18n} from '../i18n';
import {B64Image} from './B64Image';
import {comm} from '../comm';
const RoutesLazy = React.lazy(() => import('./RoutesLazy'));

window.router = history;
window.toJS = toJS;

window.gameTimeouts = [];
window.gameSetTimeout = function (f, delay, ...rest) {
	const id = setTimeout(f, delay, ...rest);
	window.gameTimeouts.push(id);
	return id;
};

const AppBody = styled.div`
	height: 100vh;
	width: 100vw;
	background: ${ 'rgb(63, 87, 177)'}; 
	background: url('/assets/skin/gameBkg.jpg') center/cover, 
		${ 'linear-gradient(0deg, rgba(63, 87, 177, 1) 0%, rgba(49, 108, 205, 1) 100%)'};

	--bar-height: ${store.topBar.heightWide};
	@media (max-aspect-ratio: ${store.topBar.wtRatio}) {
		--bar-height: ${store.topBar.heightTall};
	}
	--tb-icon-height: calc(0.8 * var(--bar-height));
`;

const Debug = styled.div`
	min-height: 2em;
	max-height: 400px;
	box-sizing: border-box;
	overflow: auto;
	background-color: rgba(255, 255, 255, 0.75);
	opacity: 0.75;
	text-shadow: none;
	color: black;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100vw;
	pointer-events: none;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	z-index: 1000000;
	padding: 0.5em 1em;
	& > div {
		padding: 2px;
		&:nth-child(even) {
			color: red;
		}
	}
`;

const ForAssetPreloading = styled.div`
	visibility:hidden;
`;
@observer
export class Main extends Component {
	@observable windowSizeStable = false;

	@observable online = true;
	@observable restartWhenOnline = false;

	constructor(props) {
		super(props);
		var bootCount = parseFloat(localStorage.getItem('bootCount')) + 1 || 1;
		window.setPersistentStorage('bootCount', bootCount);
		integration.postEvent(bootCount === 1 ? 'visit_new' : 'visit_repeat', 'user')

		const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
		store.isMobile = regex.test(navigator.userAgent)
		integration.postEvent(store.isMobile ? 'visit_device' : 'visit_browser', 'user', navigator.userAgent)

		// start server communication
		comm.Login()
		.then(response => {
			store.balance = response.balance;
			store.stakes = response.betAmounts
			// TODO R7 event game_loaded - here?

			/* return comm.CheckOngoing()
		}).then(() => {	 */
			// TOO check and show resume if needed
			// else
			if(localStorage.getItem('rules_viewed') === 'true') { // || bootCount > 1?
				store.showPaytable = 'appear';
			} else
				store.showSkillzRules = 1;		
		});

		//push location into the memory history
		// remove 'index.html' from Redirect flow
		history.push(window.location.pathname.replace(/index.html/g, ''));

		store.user = new User(store);
		// instead of login flow
		store.user.isReady = true;
		store.loginComplete = true;
		store.currentTosId = 1;

		window.addEventListener('resize', this.waitForSize);
		this.waitForSize();
		window.addEventListener('online', () => {
			this.online = true;
			store.forceRemoveSpinner();
			if (this.restartWhenOnline) {
				window.restartWebview();
			}
		});
		window.addEventListener('offline', () => {
			this.online = false;
			store.forceRemoveSpinner();
		});
	}

	waitForSize = debounce(() => {
		if (window.innerHeight > 300 && window.innerWidth > 300) {
			this.windowSizeStable = true;
			store.recalcAspectRatio();
		} else {
			this.waitForSize();
		}
	}, 2500);


	@computed get showSplash() {
		return false
		/* return (	//!store.preventReturnToSplash &&
					(	store.preloading || store.firstTimeRules ||
						!store.user.isReady ||
						!store.tosIsAccepted ||
						(store.user.hasSeenOrSkippedTutorial && store.user.mustLogin)
					)
					//&& store.modal !== 'switchAccount'
					&& store.modal !== 'regionNotAllowed'
				)
			|| (this.online === false && this.restartWhenOnline); */
	}
	render() {
		//console.log('user is logged in', store.user.guest.serverData.AnonymousUsername);
		const networkOfflineImg = vis => (
			<Error vis={vis}>
				<Sprite
					onClick={() => {
						window.manager.playAudio('poopPop');
						this.restartWhenOnline = true;
					}}
					localize
					w={80}
					sprite="popup_box_connectionError.png"
				/>
			</Error>
		);

		const generalErrorImg = (
			<Sprite onClick={window.restartWebview} localize w={80} sprite="popup_box_serverError.png" />
		);

		return (
			<Router history={history}>
				<AppBody className={store.aspectName}>
					<ForAssetPreloading>
						<Spinner />
					</ForAssetPreloading>
					{this.showSplash ? (
						<Splash tos={store.currentTosId} />
					) : (
						<Suspense fallback={<div></div>}>
							<RoutesLazy/>
						</Suspense>
					)}
					{this.windowSizeStable && (
						<div
							key="phaserWrap"
							style={{
								display: store.activeMatch ? 'block' : 'none',
								zIndex: store.activeMatch ? 100 : -100,
								position: 'absolute',
								height: '100%',
								width: '100%',
								top: store.activeMatch ? 0 : 10000,
								left: 0,
							}}
						>
							<PhaserGame key={`phaser-${store.phaserInstanceIndex}`} />
						</div>
					)}

					{(store.debug !== '') && (
						<Debug>{`${store.debug}`}</Debug>
					)}

					{!store.user.hasSeenOrSkippedTutorial && <TutorialPreload />}
					{networkOfflineImg(!this.online)}
					{this.online && <AnimatePresence>
						{store.spinner && <Spinner />}
					</AnimatePresence>}
					{/* {!this.online	? <Error>{networkOfflineImg}</Error>
						: <AnimatePresence>{store.spinner && <Spinner />}</AnimatePresence>	} */}
					{!!store.errorMessage && <Error vis={true}>{generalErrorImg}</Error>}
					{store.aspectIs('Landscape') && <LandscapeMessage/>}
				</AppBody>
			</Router>
		);
	}
}
const LandscapeMessage = styled(p => { return (
	<div className={p.className}>
		<B64Image src='assets/lobby/rotate_device_phone_black.png'/>
		<div>
			<p>{i18n.t('landscape_1')}</p>
			<p>{i18n.t('landscape_2')}</p>
		</div>
	</div>
)})`
	width: 100vw;		height: 100vh;
	position: absolute;    z-index: 5000;
    top: 0;    left: 0;
	background-color: #000000;
	display: flex;		gap: 5vw;
	align-items: center;
	img {	height: min(35vw, 60vh); }
	color: white;
	font-size: 5vw;
    padding: 0 2vw;
	p { margin-block: 0.5em;}
`;

const Error = styled.div`
	z-index: 10000;
	position: absolute;
	width: 100%;
	text-align: center;
	top: 0; left: 0;
	height: 100vh;
	background: rgba(0, 0, 0, 0.75);
	padding-top: 20vw;
	visibility: ${p => p.vis ? 'visible' : 'hidden'}
`;
